import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

const Loading = ({ showClearStorageBtn = false }) => {
  const navigate = useNavigate();
  const handleCacheClear = () => {
    navigate('/clear-client-storage', { replace: true });
  };
  return (
    <div style={{ padding: '14px' }}>
      <b>Loading... </b>
      <br />
      <br />
      {showClearStorageBtn && (
        <>
          <i>
            If you are seeing this page for long time. Try clearing
            storage/cache.
          </i>
          <br />
          <button type="button" onClick={handleCacheClear}>
            Clear Storage/Cache
          </button>
        </>
      )}
    </div>
  );
};

Loading.propTypes = {
  showClearStorageBtn: PropTypes.bool,
};

export default Loading;
